import { useState } from "react";
import { cn } from "@/lib/utils";
import { SmartImage } from "./SmartImage";

export const AutoAspectImage = ({
  src,
  alt = "",
  label,
  className,
  wrapperClassName,
  ...rest
}) => {
  const [ratio, setRatio] = useState(null);

  return (
    <div
      className={cn("overflow-hidden", wrapperClassName ?? "aspect-[4/5]")}
      style={ratio ? { aspectRatio: ratio } : undefined}
    >
      <SmartImage
        src={src}
        alt={alt}
        label={label}
        className={cn("h-full w-full object-cover", className)}
        onLoad={(e) => {
          const img = e.currentTarget;
          if (img.naturalWidth && img.naturalHeight) {
            setRatio(img.naturalWidth / img.naturalHeight);
          }
        }}
        {...rest}
      />
    </div>
  );
};

export default AutoAspectImage;